import { useEventListener } from '@vueuse/core';

const handleTweetLoad = (iframe: HTMLIFrameElement) => {
    const pendingTweets = new Set<HTMLIFrameElement>();

    pendingTweets.add(iframe);

    const handleMessage = (event) => {
        if (event.origin === 'https://platform.twitter.com' && event.source === iframe.contentWindow) {
            if (event.data['twttr.embed'].method === 'twttr.private.resize') {
                const heightValue = event.data['twttr.embed'].params[0].height;
                iframe.style.height = `${heightValue}px`;
                pendingTweets.delete(iframe);
            }
        }
    };

    useEventListener('message', handleMessage);
};

const addEventsToIframes = () => {
    const iframesSet = new Set<HTMLIFrameElement>();

    const iframes = document.querySelectorAll<HTMLIFrameElement>('iframe.twitter-embed');

    iframes.forEach((iframe) => {
        if (iframesSet.has(iframe)) {
            return;
        }

        handleTweetLoad(iframe);
        iframesSet.add(iframe);
    });
};

useEventListener(document, 'DOMContentLoaded', addEventsToIframes);
useEventListener(window, 'infinite-scroll-append', addEventsToIframes);
